import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

import { RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { environment } from '../../environments/environment';
import { AppRoutingModule } from '../router/app-routing.module';
import { TranslateService } from './translate.service';

import { TRANSLATION_PROVIDERS } from './translations';
import { BackendService } from './backend.service';
import { CsvmapperService } from './csv.service';

import {
  EnvironmentProvider,
  StorageProvider,
  HistoryProvider,
  LocationProvider,
} from './browser-providers';
import { ApiService } from './api.service';
import { ClienteService } from './cliente.service';
import { RoleService } from './role.service';
import { UserService } from './user.service';

const modules = [
  HttpModule,
  FormsModule,
  RouterModule,
  AppRoutingModule,
  ReactiveFormsModule,
];

@NgModule({
  imports: modules,
  exports: modules,
  providers: [
    { provide: EnvironmentProvider, useValue: environment },
    { provide: StorageProvider, useValue: localStorage },
    { provide: HistoryProvider, useValue: history },
    { provide: LocationProvider, useValue: location },
    TranslateService,
    TRANSLATION_PROVIDERS,
    ApiService,
    BackendService,
    ClienteService,
    RoleService,
    UserService,
    CsvmapperService
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts